export enum Features {
  SEO = 'seo',
  BusinessCitations = 'businesscitations',
  BusinessProfileManagement = 'businessprofilemanagement',
  StandaloneBacklink = 'standalonebacklink',
  PageOptimization = 'pageoptimization',
  StarterSEO = 'starterseo'
}
